import URL from 'url';
import axios, { AxiosRequestConfig } from 'axios';
import { v5 as uuidv5 } from 'uuid';

export { AxiosProxyConfig } from 'axios';

const HOSTS_WITH_QUERY_STRING_USED_ON_ID = ['news.google.com', 'youtube.com'];

interface IRequestConfig extends AxiosRequestConfig {
  timeout?: number
}

/**
 * Executes an axios request enforcing timeouts.
 */
export async function requestWithTimeout(requestConfig: IRequestConfig) {
  const { timeout } = requestConfig;
  let timer;

  try {
    let cancelToken;

    if (timeout) {
      const source = axios.CancelToken.source();
      cancelToken = source.token;

      // @see https://stackoverflow.com/questions/36690451/timeout-feature-in-the-axios-library-is-not-working
      timer = setTimeout(() => {
        source.cancel();
      }, timeout);
    }
    const response = await axios({ ...requestConfig, cancelToken });

    return response;
  } catch (err) {
    if (timeout && axios.isCancel(err)) {
      throw new Error(`Request timed out after ${timeout} millis`);
    }
    throw err;
  } finally {
    if (timer) {
      clearTimeout(timer);
    }
  }
}

/**
 * Builds an uuid based on an URL.
 */
export function getUrlId(url: string) {
  const { host, pathname, search } = URL.parse(url.trim());

  let cleanPath = pathname;
  if (pathname && pathname.endsWith('/')) {
    // remove trailing dash
    cleanPath = pathname.slice(0, -1);
  }

  let uniqueURL = `${host}${cleanPath}`;

  if (
    search
    && HOSTS_WITH_QUERY_STRING_USED_ON_ID.some((h) => host?.includes(h))
  ) {
    // let some hosts keep their query strings
    uniqueURL += search;
  }
  return uuidv5(uniqueURL, uuidv5.URL);
}
